import PropTypes from 'prop-types';

import {
  H1,
  H2,
  H3,
  H4,
  Paragraph,
} from './styled';
import types from './types';
import variants from './variants';

const generateText = {
  [types.headingXXL]: H1,
  [types.headingXL]: H2,
  [types.headingL]: H3,
  [types.subHeading]: H4,
  textLead: Paragraph,
  textBasis: Paragraph,
  textBasisMedium: Paragraph,
  textBasisBold: Paragraph,
  textSmall: Paragraph,
  textSmallMedium: Paragraph,
  textExtraSmall: Paragraph,
  textExtraSmallMedium: Paragraph,
};

const CustomText = ({
  text,
  variant,
  type,
  className,
  whiteSpace,
  children,

  innerRef,
}) => {
  let Component = generateText[type];

  if (!Component) {
    Component = generateText.textBasis;
    // eslint-disable-next-line no-param-reassign
    type = types.textBasis;
  }

  return (
    <Component
      type={type}
      variant={variant} // eslint-disable-next-line react/jsx-props-no-spreading
      className={className}
      whiteSpace={whiteSpace}
      ref={innerRef}
    >
      {text || children}
    </Component>
  );
};

CustomText.propTypes = {
  type: PropTypes.oneOf(Object.values(types)),
  variant: PropTypes.oneOf(Object.values(variants)),
  text: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  whiteSpace: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Object) }),
  ]),
};
CustomText.defaultProps = {
  type: types.textBasis,
  variant: variants.darkBlue,

  text: '',
  children: undefined,
  className: '',
  whiteSpace: null,
  innerRef: null,
};

export default CustomText;
